import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.bind";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.create";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.for-each";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function setState(store, newState, afterUpdateCallback) {
  store.state = _objectSpread(_objectSpread({}, store.state), newState);
  store.listeners.forEach(function (listener) {
    listener.run(store.state);
  });
  afterUpdateCallback && afterUpdateCallback();
}

function useCustom(store, React, mapState, mapActions) {
  var _React$useState = React.useState(Object.create(null)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      originalHook = _React$useState2[1];

  var state = mapState ? mapState(store.state) : store.state;
  var actions = React.useMemo(function () {
    return mapActions ? mapActions(store.actions) : store.actions;
  }, [mapActions, store.actions]);
  React.useEffect(function () {
    var newListener = {
      oldState: {}
    };
    newListener.run = mapState ? function (newState) {
      var mappedState = mapState(newState);

      if (mappedState !== newListener.oldState) {
        newListener.oldState = mappedState;
        originalHook(mappedState);
      }
    } : originalHook;
    store.listeners.push(newListener);
    newListener.run(store.state);
    return function () {
      store.listeners = store.listeners.filter(function (listener) {
        return listener !== newListener;
      });
    };
  }, []); // eslint-disable-line

  return [state, actions];
}

function associateActions(store, actions) {
  var associatedActions = {};
  Object.keys(actions).forEach(function (key) {
    if (typeof actions[key] === "function") {
      associatedActions[key] = actions[key].bind(null, store);
    }

    if (typeof actions[key] === "object") {
      associatedActions[key] = associateActions(store, actions[key]);
    }
  });
  return associatedActions;
}

var useStore = function useStore(React, initialState, actions, initializer) {
  var store = {
    state: initialState,
    listeners: []
  };
  store.setState = setState.bind(null, store);
  store.actions = associateActions(store, actions);
  if (initializer) initializer(store);
  return useCustom.bind(null, store, React);
};

export default useStore;